import { Form } from "src/app/services/response-models/form.response.model";

export class SetFormToEdit {
    static readonly type = "[Form Templates] Load form to edit";

    constructor(public payload: Form) {}
}
